import React from 'react';

import Icon from '../Icon/Icon';

const ExtraFeaturesIcon = (props) => {
    return (
        <Icon width='64' height='64' {...props}>
            <g fill='none' fillRule='evenodd'>
                <path
                    d='M19 55c-.935 0-1.935-1.536-3-4.607V16.046c0-1.434.597-2.782 1.79-4.046h6.42c1.193 1.264 1.79 2.612 1.79 4.046v34.347C24.935 53.464 23.935 55 23 55z'
                    stroke='#34303D'
                    strokeWidth='2.667'
                    strokeLinejoin='round'
                />
                <circle stroke='#00D1D2' strokeWidth='1.333' fill='#34303D' cx='21' cy='30.913' r='2' />
                <path
                    d='M46.667 45.333v6.334a3 3 0 0 1-3 3h-9.334a3 3 0 0 1-3-3V12.333a3 3 0 0 1 3-3H39A7.667 7.667 0 0 1 46.667 17v12.639'
                    stroke='#34303D'
                    strokeWidth='2.667'
                />
                <g transform='translate(40 28.413)' stroke='#34303D' strokeWidth='2'>
                    <circle fill='#00D1D2' cx='9.014' cy='9.014' r='8.014' />
                    <path strokeLinecap='round' strokeLinejoin='round' d='m5.68 9.467 1.885 1.973 4.782-4.912' />
                </g>
            </g>
        </Icon>
    );
};

export default ExtraFeaturesIcon;
